"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changesMadeToUnderEditImageData = void 0;
var lodash_1 = require("lodash");
/**
   * we have to shove the defaults into imageData,
   * else equality check wont work
   */
var changesMadeToUnderEditImageData = function (_a) {
    var imageData = _a.imageData, underEditImageData = _a.underEditImageData, defaultImageSpread = _a.defaultImageSpread;
    var fullImageData = __assign(__assign({ imageSpread: defaultImageSpread, imageRotate: 0, cropX: 0, cropY: 0 }, imageData), { caption: undefined //we dont compare changes in caption
     });
    var fullUnderEditImageData = __assign(__assign({ imageSpread: defaultImageSpread, imageRotate: 0, cropX: 0, cropY: 0 }, underEditImageData), { caption: undefined });
    return !(0, lodash_1.isEqual)(fullImageData, fullUnderEditImageData);
};
exports.changesMadeToUnderEditImageData = changesMadeToUnderEditImageData;
